import { getCurrentUser, Profile } from '@creditsights/api-ui-web';
import { useQuery, UseQueryResult } from 'react-query';
import { USER_PROFILE_CACHE_KEY } from '../../Constants';
import { fetchUserProfile } from '../../services/user.service';

export default (): UseQueryResult<Profile, Error> => {
  const { userId } = getCurrentUser();
  return useQuery([USER_PROFILE_CACHE_KEY, userId], async () => fetchUserProfile());
};
